import { useEffect, useState } from "react";
import { MapPin, TrendingUp, ShieldAlert } from "lucide-react";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import SectionHeading from "../components/SectionHeading";

export default function Invest() {
  const { openLead } = useApp();
  const [inv, setInv] = useState([]);
  useEffect(() => { api.investments().then(setInv).catch(() => {}); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
      <SectionHeading eyebrow="Invest" title="Real Estate Opportunities Beyond the Ordinary"
        subtitle="Curated avenues to research across asset classes and horizons." />
      <div className="flex items-start gap-2.5 bg-pbs-gold/10 border border-pbs-gold/40 rounded-xl p-4 mb-8">
        <ShieldAlert size={18} className="text-pbs-orange shrink-0 mt-0.5" />
        <p className="text-sm text-pbs-dark/80">These are opportunities to <strong>explore and research</strong>, presented with market context only. PlotBySquare does not offer or imply any guaranteed returns.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {inv.map((i) => (
          <div key={i.id} data-testid={`invest-${i.id}`} className="bg-white rounded-2xl border border-pbs-line overflow-hidden pbs-shadow hover:pbs-shadow-hover transition-shadow group">
            <div className="relative aspect-[16/9] overflow-hidden">
              <img src={i.image} alt={i.title} loading="lazy" className="w-full h-full object-cover zoom-img" />
              <span className="absolute top-3 left-3 bg-pbs-purple text-white text-[11px] font-bold px-2.5 py-1 rounded-md">{i.type}</span>
            </div>
            <div className="p-5">
              <h3 className="font-bold text-lg text-pbs-dark">{i.title}</h3>
              <p className="text-sm text-pbs-grey mt-1 flex items-center gap-1"><MapPin size={13} className="text-pbs-purple" /> {i.location}</p>
              <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                <KV label="Entry Price" value={i.entry_price} />
                <KV label="Holding Period" value={i.holding_period} />
                <KV label="Potential Use" value={i.potential_use} />
                <KV label="Type" value={i.type} />
              </div>
              <div className="mt-3 flex flex-wrap gap-1.5">{i.highlights.map((h) => <span key={h} className="inline-flex items-center gap-1 text-[11px] bg-pbs-bg border border-pbs-line px-2 py-0.5 rounded-full text-pbs-dark/80"><TrendingUp size={10} className="text-pbs-purple" /> {h}</span>)}</div>
              <button onClick={() => openLead({ type: "enquiry", title: `Investment: ${i.title}` })} className="mt-4 w-full text-center text-sm font-bold text-white rounded-lg py-2.5 pbs-gradient">Explore Opportunity</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
const KV = ({ label, value }) => (<div><p className="text-[11px] text-pbs-grey">{label}</p><p className="font-semibold text-pbs-dark text-sm leading-tight">{value}</p></div>);
